import { Fragment, useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getHoldingReport} from '../../../actions/hpmAction';
import { getUserPreference } from "../../../utilities/common";
import { makeStyles } from '@material-ui/core/styles';
import { Table } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import _ from "lodash";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '100%'
    },
    textFieldStyle: {
        width: '70%',
        marginRight: 10
    },
    buttonStyle: {
        width: '30%'
    },
    tableRowColor: {
        background: '#212121'
    },
    tableCellFormat: {
        fontSize: '1.2rem',
        textAlign: 'center'
    },
    tableCellContentFormat: {
        textAlign: 'center'
    }
}));
function HoldingReport(props) {
    const classes = useStyles();
    const {t} = useTranslation('holdingPackagesManagement');
    const dispatch = useDispatch();
    let userPref = getUserPreference();

    const [report, setReport] = useState([]);
    const [summary, setSummary] = useState([]);
    const [expandedToScan, setExpandedToScan] = useState(false);
    const handleChangeToScan = (panel) => (event, isExpanded) => {
        setExpandedToScan(isExpanded ? panel : false);
    };

    useEffect(() => {
        if(props.report && props.summary) {
            setReport(props.report);
            setSummary(props.summary);
        }        
    }, [props.summary, props.report])

    return (
        <Fragment>
            {
                (summary.length > 0) && <Accordion expanded={expandedToScan === 'panel1'} onChange={handleChangeToScan('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography >{t('summary')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.tableRowColor}>
                                    <TableCell className={classes.tableCellFormat} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <span onClick={sortBySegment} style={{ cursor: 'pointer', marginRight: 10 }}>
                                            <SortByAlphaIcon/>
                                        </span>
                                        <span>
                                            {t('segment')}
                                        </span>    
                                    </TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('total_searching')}</TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('total_found')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (summary.length > 0) && report.map((record, index) => {
                                        return (
                                            <TableRow 
                                                key={record}
                                                style={ index % 2? { background : "#424242" }:{ background : "#303030" } }
                                            >
                                                <TableCell className={classes.tableCellContentFormat}>{record.segment}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record.total_searching}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record.total_found}</TableCell>
                                            </TableRow>
                                        );
                                    })    
                                }                
                            </TableBody>
                        </Table>
                    </AccordionDetails>
                </Accordion>
            }
            {
                (report.length > 0) && <Accordion expanded={expandedToScan === 'panel2'} onChange={handleChangeToScan('panel2')} style={{ marginTop: 20 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography >{t('report')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>

                        <Table style={{ marginTop: 20 }}  size={'medium'}>
                            <TableHead>
                                <TableRow className={classes.tableRowColor}>
                                    <TableCell className={classes.tableCellFormat} >
                                        <span onClick={sortBySegment} style={{ cursor: 'pointer', marginRight: 10 }}>
                                            <SortByAlphaIcon/>
                                        </span>
                                        <span>
                                            {t('segment')}
                                        </span>                           
                                    </TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('owner')}</TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('tno')}</TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('bag_no')}</TableCell>        
                                    <TableCell className={classes.tableCellFormat}>{t('is_found')}</TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('scanner')}</TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('scanned_time')}</TableCell>
                                    <TableCell className={classes.tableCellFormat}>{t('operator')}</TableCell>
                                    <TableCell  className={classes.tableCellFormat}>{t('notes')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (report.length > 0) && report.map((record, index) => {
                                        return (
                                            <TableRow 
                                                key={record}
                                                style={{ width: 50 ,height:'auto'}}
                                                style={ index % 2? { background : "#424242" }:{ background : "#303030" } }
                                            >
                                                <TableCell className={classes.tableCellContentFormat}>{record.segment}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record.owner}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record.tno}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record.bag_no}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record.is_found}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record.scanner}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{displayScannedTime(record.scanned_time)}</TableCell>
                                                <TableCell className={classes.tableCellContentFormat}>{record?.operator||'N/A'}</TableCell>
                                                <TableCell  padding={'normal'}className={classes.tableCellContentFormat}>{record?.notes || 'N/A'}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                            </TableBody>
                        </Table>


                    </AccordionDetails>
                </Accordion>
            }
        </Fragment>
    );

    function sortBySegment() {
        dispatch(getHoldingReport(userPref.userCity, props.blockBatch, 1))
            .then((res) => {
                setReport(res.report);
                setSummary(res.summary);
            })
    }

    function displayScannedTime(scanned_time) {
        if (!_.isNil) {
            return moment.unix(scanned_time).format("YYYY-MM-DD, HH:mm:ss");
        } else return 'N/A';
    }

}

export default HoldingReport;